<template>
  <div class="ui-input-details">
    <div class="v-messages theme--light error--text">
      <div class="v-messages__wrapper">
        <div class="v-messages__message">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  errorMessages?: string | string[] | null;
}>();

const message = computed(() => props.errorMessages && props.errorMessages[0]);
</script>

<style lang="scss">
.ui-input-details {}
</style>
